export const SidebarTranslations = {
  en: {
    sidebar: {
      home: "Home",
      profile: "Profile",
      catalog: "Catalog",
      settings: "Settings",
      logout: "Log Out",
    },
  },
  es: {
    sidebar: {
      home: "Inicio",
      profile: "Perfil",
      catalog: "Catálogo",
      settings: "Ajustes",
      logout: "Salir",
    },
  },
};
